import script from "./AIPromptCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./AIPromptCollect.vue?vue&type=script&setup=true&lang=js"

import "./AIPromptCollect.vue?vue&type=style&index=0&id=40e5c630&lang=less"

const __exports__ = script;

export default __exports__